import React from 'react';
import { useGameState } from './hooks/useGameState';
import { IntroScreen, GameScreen, CompleteScreen } from './components/GameScreens';
import './styles/terminal.css';

/**
 * Test Detective - QA Investigation Challenge Game
 * 
 * A terminal-styled game that tests QA skills through various challenge types:
 * - Coverage Gap: Identify missing test cases
 * - Bug Hunt: Find problems with existing tests
 * - Requirements: Spot issues in specifications
 * - Spot the Bug: Find defects in code
 * 
 * @author Jeff Heytow
 */
function App() {
  const {
    gameState,
    currentLevel,
    totalLevels,
    score,
    selectedAnswer,
    showExplanation,
    timeLeft,
    answers,
    bootSequence,
    currentChallenge,
    startGame,
    handleAnswer,
    nextLevel,
    restartGame,
    getResults
  } = useGameState();

  return (
    <div className="terminal-container">
      {/* CRT Scanlines Effect */}
      <div className="scanlines" />
      
      {/* Render appropriate screen based on game state */}
      {gameState === "intro" && (
        <IntroScreen 
          bootSequence={bootSequence} 
          onStart={startGame} 
        />
      )}
      
      {gameState === "playing" && (
        <GameScreen
          currentLevel={currentLevel}
          totalLevels={totalLevels}
          challenge={currentChallenge}
          score={score}
          timeLeft={timeLeft}
          selectedAnswer={selectedAnswer}
          showExplanation={showExplanation}
          onAnswer={handleAnswer}
          onNext={nextLevel}
        />
      )}
      
      {gameState === "complete" && (
        <CompleteScreen
          results={{ score, ...getResults() }}
          answers={answers}
          onRestart={restartGame}
        />
      )}
    </div>
  );
}

export default App;
